<template>
  <div>
    <ConfettiExplosion
      v-for="c of explosions"
      :key="c.id"
      :style="`top: -15px; left: ${c.id * 400}px;`"
      class="confetti"
      :colors="colors"
    ></ConfettiExplosion>
  </div>
</template>

<script lang="ts" setup>
import { nextTick, ref } from 'vue'
import ConfettiExplosion from 'vue-confetti-explosion'
const colors = ['#4886ff', '#ff3f25', '#ffb774']
const explosions = ref<{ id: number }[]>([])

const explode = async () => {
  const item = {
    id: Math.random()
  }
  const item2 = {
    id: Math.random()
  }
  explosions.value.push(item)
  await nextTick()
  setTimeout(() => {
    explosions.value = explosions.value.filter((i) => i.id !== item.id)
  }, 3000)
}
defineExpose({
  explode
})
</script>
